import type {AreaGraphEditableWidget, AreaGraphWidget} from "~/components/reports/widgetSpecific/areaGraph";
import type {MultiBarGraphEditableWidget, MultiBarGraphWidget} from "~/components/reports/widgetSpecific/barGraph";
import type {ComboChartEditableWidget, ComboChartWidget} from "~/components/reports/widgetSpecific/comboChart";
import type {DonutChartEditableWidget, DonutChartWidget} from "~/components/reports/widgetSpecific/donutChart";
import type {GaugeEditableWidget, GaugeWidget} from "~/components/reports/widgetSpecific/gauge";
import type {HorizontalBarGraphEditableWidget, HorizontalBarGraphWidget} from "~/components/reports/widgetSpecific/horizontalBarGraph";
import type {ImageEditableWidget, ImageWidget} from "~/components/reports/widgetSpecific/image";
import type {LineGraphEditableWidget, LineGraphWidget} from "~/components/reports/widgetSpecific/lineGraph";
import type {NumberTileEditableWidget, NumberTileWidget} from "~/components/reports/widgetSpecific/numberTile";
import type {PieChartEditableWidget, PieChartWidget} from "~/components/reports/widgetSpecific/pieChart";
import type {ProgressBarEditableWidget, ProgressBarWidget} from "~/components/reports/widgetSpecific/progressBar";
import type {StackedBarGraphEditableWidget, StackedBarGraphWidget} from "~/components/reports/widgetSpecific/stackedBarGraph";
import type {TableEditableWidget, TableWidget} from "~/components/reports/widgetSpecific/table";
import type {TextEditableWidget, TextWidget} from "~/components/reports/widgetSpecific/text";

export enum WidgetLoadingState {
    notRequired = "ef6d90ea-8741-48ec-ae69-4afbfda72304",
    incompleteWidget = "8384d58d-cc74-4967-b3a3-6123d43253b6",
    notStarted = "b46c3265-abb1-4d10-80db-349dd6317257",
    loading = "a41d58b5-72ae-4511-b2f1-0cfcdcbc53da",
    errorAfterLoading = "56dc1e99-4565-43b0-9c9f-214c4e2307a6",
    loadedSuccessfully = "805f9bd8-9dad-4544-8740-4d8eec8eeda9",
}

export type Widget =
    | MultiBarGraphWidget
    | StackedBarGraphWidget
    | HorizontalBarGraphWidget
    | LineGraphWidget
    | NumberTileWidget
    | PieChartWidget
    | DonutChartWidget
    | TextWidget
    | ImageWidget
    | TableWidget
    | ProgressBarWidget
    | GaugeWidget
    | AreaGraphWidget
    | ComboChartWidget;

export type EditableWidget =
    | MultiBarGraphEditableWidget
    | StackedBarGraphEditableWidget
    | HorizontalBarGraphEditableWidget
    | LineGraphEditableWidget
    | NumberTileEditableWidget
    | PieChartEditableWidget
    | DonutChartEditableWidget
    | TextEditableWidget
    | ImageEditableWidget
    | TableEditableWidget
    | ProgressBarEditableWidget
    | GaugeEditableWidget
    | AreaGraphEditableWidget
    | ComboChartEditableWidget;
